export default function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isNumber.js
// module id = 742
// module chunks = 1